import React, { forwardRef, useImperativeHandle, useEffect, useState, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
//fontawesome
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
//horizontalScroll
import ScrollContainer from 'react-indiana-drag-scroll';
//select
import SelectSearch from 'react-select-search';
import 'src/asset/scss/plugin/select.scss';
//styles
import styles from 'src/asset/scss/styles/userPartnerItemReg.module.scss';
//hooks
import useComnHook from 'src/webapp/hooks/comn/comn.hook';
import useUploadFileHook from 'src/webapp/hooks/comn/uploadFile.hook';
import useAxiosHook from 'src/webapp/hooks/comn/axios.hook';
//store
import useAdminStore from 'src/webapp/stores/admin.store';
import useComnStore from 'src/webapp/stores/comn.store';
//CompWrapper
import Element from 'src/webapp/views/wrapper/Element';
import FormWrapper from 'src/webapp/views/wrapper/form/Form';//입력폼
import TitleWrapper from 'src/webapp/views/wrapper/form/Title';//입력폼내제목
import Button from '../../component/Button';
//comp

export const Form = forwardRef((props, ref) => {
    useImperativeHandle(ref, () => ({//상위컴포넌트에서 호출
        onSubmitHandler
    }));

    const onSubmitHandler = () => {
        productRegAndUpdateAPI()
    }
    const { state } = useLocation();
    const navigator = useNavigate();
    const inputRef = useRef([]);//입력값
    //hook
    const { axiosMultiPartHandler, axiosPostHandler, axiosGetHandler } = useAxiosHook();
    const { onNumberCommaHandler, removeCommaHandler, debounce } = useComnHook();
    const { files, setFiles, file, setFile//fileuseState
        , MAX_COUNT//최대업로드갯수
        , addFilesHandler, addFileHandler//파일업로드핸들러
    } = useUploadFileHook();
    //store
    const { admin } = useAdminStore();
    const { setMessage } = useComnStore();
    /* ============================ State ============================ */
    const [regData, setRegData] = useState({ selectOption: null, selectRadio: null, isRaffle: "N" });// 선택옵션 및 선택라디오 State / selectRadio: 배송 방식 - 1.판매자배송, 2.풀필먼트, 3.위탁배송
    const [option, setOption] = useState({ category_1: [], category_2: [], category_3: [], });//옵션State
    const optionInputRef = useRef([]);
    const [optionData, setOptionData] = useState({ cnt: null, active: null });
    /* ============================ State ============================ */
    /* ============================ 날짜 및 시간 ============================ */
    const now = new Date();//오늘자
    const sevendaysAfter = new Date(Date.now() + 30 * 24 * 60 * 60 * 1000);//7일후
    /* =============== 가입일 =============== */
    const [startDate, setStartDate] = useState(state?.START_DT ? new Date(state.START_DT.split(".")[0]) : now);
    const [endDate, setEndDate] = useState(state?.END_DT ? new Date("20" + state.END_DT.split(" ")[0]) : sevendaysAfter);
    // datetime-local value용: "YYYY-MM-DDTHH:mm"
    const toDateTimeLocalValue = (date) => {
        const d = new Date(date);
        const pad = (n) => String(n).padStart(2, "0");
        return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
    };

    // 서버 전송용: "yyyyMMdd HH:mm:ss"
    const toServerDateTime = (date) => {
        const d = new Date(date);
        const pad = (n) => String(n).padStart(2, "0");
        return `${d.getFullYear()}${pad(d.getMonth() + 1)}${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    };
    /* ============================ 날짜 및 시간 ============================ */
    /* ====================== 카테고리코드 ====================== */
    //카테고리코드옵션 불러오기API
    const siteCategoryTreeListAPI = async (value, position) => {
        const DATA = { PARENT_CATEGORY: value, DEPT_POSITION: position, STATE: 1 };
        const result = await axiosPostHandler("siteCategoryTreeListForAdmin.do", DATA);
        const isOk = result && result.message === "SUCCESS";
        if (!isOk) { return; }
        switch (position) {
            case 1: setOption(prev => ({ ...prev, category_1: result.data })); break;
            case 2: setOption(prev => ({ ...prev, category_2: result.data })); break;
            case 3: setOption(prev => ({ ...prev, category_3: result.data }));
        }
    }
    //초기 카테고리1 불러오기
    useEffect(() => {
        if (option.category_1.length > 0) { return; }
        siteCategoryTreeListAPI(0, 1);
    }, [])
    /* ====================== 카테고리코드 ====================== */
    /* ====================== 파트너코드 ====================== */
    const [partnerList, setPartnerList] = useState(null);
    const [selectPartner, setSelectPartner] = useState(null);
    const partnerListAPI = async (value) => {//0:무한로드, 1:검색 
        try {
            const DATA = { ROWNUM: 20, PARTNER_NAME: value, STATE: '' };
            const result = await axiosPostHandler(`partnerMasterListForAdmin.do`, DATA);
            const isOk = result && result.message === "SUCCESS";
            if (!isOk) { return; }
            setPartnerList(result.data);
        } finally { isLock.current = false; }
    }
    const debouncedHandler = useRef(debounce(partnerListAPI, 300));
    /* ====================== 파트너코드 ====================== */
    /* ==================== 장르선택 ==================== */
    const [vehicleTypeList, setVehicleTypeList] = useState([]);//상품장르데이터리스트State
    //상품장르데이터호출API
    const vehicleTypeListAPI = async () => {
        const result = await axiosGetHandler("vehicleTypeListForAdmin.do");
        const isOk = result && result.message === "SUCCESS";
        if (!isOk) { return; }
        setVehicleTypeList(result.data);
    }
    useEffect(() => {
        if (vehicleTypeList.length > 0) { return; }
        vehicleTypeListAPI();
    }, [])

    const [selectVehicleTypeList, setSelectVehicleTypeList] = useState([]);//선택한상품장르State
    //장르선택핸들러
    const chooseVehicleTypeHandler = (value) => {
        const selected = vehicleTypeList.find(item => item.value === value);
        const data = { value: value, name: selected?.name };

        const exists = selectVehicleTypeList.some(item => item.value === data.value);

        if (exists) { return; }

        setSelectVehicleTypeList(prev => [...prev, data]);
    };
    /* ==================== 장르선택 ==================== */
    /* ====================== 상품등록및 수정 API ====================== */
    const isLock = useRef(false);
    const productRegAndUpdateAPI = async () => {//type - 1.등록, 2.수정, 3.부분수정
        try {
            const type = state ? "수정" : "등록";
            if (isLock.current) { return; }
            isLock.current = true;

            const DATA = new FormData();
            let variables = {
                MASTER: {
                    ITEM_NAME: inputRef.current[0].value,
                    DESCRIPTION: inputRef.current[1].value,
                    PARTNER_CD: selectPartner.PARTNER_CD,
                    CATEGORY_CD: regData.selectOption,
                    ORIGIN_PRICE: removeCommaHandler(inputRef.current[2].value),
                    SALE_PRICE: removeCommaHandler(inputRef.current[3].value),
                    START_DT: toServerDateTime(startDate),
                    END_DT: toServerDateTime(endDate),
                    SHIP_OUT_DT: inputRef.current[4].value,
                    ITEM_DESC: inputRef.current[5].value,
                    MAX_QTY_PER_USER: inputRef.current[10].value,
                    IS_RAFFLE: regData.isRaffle,
                    TYP_CD_LIST: selectVehicleTypeList.map(item => item.value).join(", ")
                },
                SHIP_POLICY: {
                    SHIP_TYP: regData.selectRadio,
                    BASE_FEE: removeCommaHandler(inputRef.current[7].value),
                    FREE_COND_AMT: removeCommaHandler(inputRef.current[8].value),
                    JEJU_EXTRA_FEE: removeCommaHandler(inputRef.current[9].value),
                },
                REG_INFO: { ADMIN_ID: admin.COMN_ID, STATE: state ? 2 : 1 }
            };
            let skuList = [];
            if (optionData.active) {// 옵션 사용
                skuList = (optionInputRef.current || [])
                    .filter(row => row?.[0] && row?.[1] && row?.[2])
                    .map(row => ({
                        OPTION_NAME: row[0].value,
                        OPTION_VALUE: removeCommaHandler(row[1].value),
                        STOCK_QTY: removeCommaHandler(row[2].value),
                    }));
            } else {
                // 옵션 미사용 기본 ONE SIZE
                skuList = [{
                    OPTION_NAME: "ONE SIZE",
                    OPTION_VALUE: 0,
                    STOCK_QTY: removeCommaHandler(inputRef.current[6]?.value),
                }];
            }
            // SKU가 있으면 variables에 추가
            if (skuList.length > 0) {
                variables.SKU_LIST = skuList;
            }
            for (let i = 0; i < files.length; i++) { DATA.append('files', files[i].file); }
            DATA.append("thumbnail", file[0].file);
            DATA.append('requestDTO', new Blob([JSON.stringify(variables)]), { type: "application/json" });
            const result = await axiosMultiPartHandler("siteProductUpsertForAdmin.do", DATA);
            const isOk = result && result.message === "SUCCESS";
            if (isOk) { setMessage({ type: 1, label: `상품 ${type}이 완료되었습니다.` }); navigator(-1, { replace: true }); return; }
            setMessage({ type: 2, label: `상품 ${type}에 실패 하였습니다.` });

        } finally { isLock.current = false; }
    }
    /* ====================== 상품등록및 수정 API ====================== */

    /* ==================== validationCheck ==================== */
    const makeRow = () => ({ id: crypto.randomUUID() });//추가옵션 객체 key값용 난수 생성
    const onValidateHandler = () => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);

        if (files.length <= 0 || file === null || regData.selectOption === null || regData.selectRadio === null || selectPartner === null || selectVehicleTypeList.length <= 0) {
            props.onValid(null, true);
            return;
        }
        if (optionData.active) {//옵션 활성화시 옵션내 빈값검증
            const rows = optionInputRef.current || [];
            const hasEmpty = rows.some(row => {
                const name = row?.[0]?.value?.trim() ?? "";
                const value = row?.[1]?.value?.trim() ?? "";
                const qty = row?.[2]?.value?.trim() ?? "";
                return name.length === 0 || value.length === 0 || qty.length === 0;
            });
            //옵션 DOM 렌더링중 발생하는 에러검증
            const hasBrokenRow = rows.some(row => !row || row.length < 3 || !row[0] || !row[1] || !row[2]);
            if (hasBrokenRow || hasEmpty) {
                props.onValid(null, true);
                return;
            }
        }

        for (let i = 0; i < inputRef.current.length; i++) {
            if (inputRef.current[i] === null) continue;
            if (inputRef.current[i]?.value?.length <= 0) {
                props.onValid(null, true);
                return;
            }
        }

        if (removeCommaHandler(inputRef.current[3].value) > removeCommaHandler(inputRef.current[2].value)) { props.onValid(null, true); return; }
        if (!state && new Date(startDate) < today) { props.onValid(null, true); return; }
        if (new Date(endDate) <= new Date(startDate)) { props.onValid(null, true); return; }

        props.onValid(null, false);
    };
    useEffect(() => {
        onValidateHandler();
    }, [startDate, endDate, file, files, regData, selectPartner, optionData, selectVehicleTypeList])
    /* ==================== validationCheck ==================== */
    return (
        <>

            <Element tag={`div`} className={styles.formArea}>
                {/* START 입력필드 */}
                {/* 이미지업로드 */}
                <FormWrapper>
                    {file == null ?
                        <Element tag={`div`} className={styles.fileArea}>
                            <Element tag={`label`} htmlFor="file"><Element tag={`span`}>대표이미지 업로드</Element><FontAwesomeIcon icon="fa-light fa-rectangle-history-circle-plus" /></Element>
                            <input onChange={(e) => addFileHandler(e)} type="file" id="file" accept='image/webp' />
                        </Element>
                        : null}
                    {file !== null &&
                        <React.Fragment>
                            <Element tag={`div`} className={styles.imgPreview}>
                                <Element tag={`div`} className={styles.previewImage}><img src={file[0]?.src ? process.env.REACT_APP_IMAGE_URL + file[0]?.src : file[0]?.url} alt="preview-img" /></Element>
                                <Button anyprop={(e) => setFile(null)} icon={`fa-light fa-pen-to-square`} label={`이미지 변경하기`} />
                            </Element>
                        </React.Fragment>
                    }
                </FormWrapper>
                <FormWrapper>
                    {files.length < MAX_COUNT.current ?
                        <Element tag={`div`} className={styles.fileArea}>
                            <Element tag={`label`} htmlFor="files"><Element tag={`span`}>상세이미지 업로드</Element><FontAwesomeIcon icon="fa-light fa-rectangle-history-circle-plus" /></Element>
                            <input onChange={(e) => addFilesHandler(e)} type="file" id="files" accept='image/webp' multiple />
                        </Element>
                        : null}
                    {files.length > 0 && <div className={styles.flexRow}>
                        {files.map((file, idx) => (
                            <React.Fragment key={idx}>
                                <Element tag={`div`} className={styles.imgPreview}>
                                    <Element tag={`div`} className={styles.previewImage}><img src={file.src ? process.env.REACT_APP_IMAGE_URL + file.src : file.url} alt="preview-img" /></Element>
                                    <Button anyprop={(e) => setFiles(prev => prev.filter(item => item !== file))} icon={`fa-light fa-pen-to-square`} label={`이미지 변경하기`} />
                                </Element>
                            </React.Fragment>
                        ))}
                    </div>}
                </FormWrapper>
                {/* 셀렉트 */}
                <div className={styles.flexRow}>
                    <FormWrapper>
                        <TitleWrapper title={"카테고리코드1"} />
                        <div className="selectArea">
                            <SelectSearch options={option.category_1} placeholder="--옵션선택--" onChange={(e) => siteCategoryTreeListAPI(e, 2)} />
                        </div>
                    </FormWrapper>
                    <FormWrapper>
                        <TitleWrapper title={"카테고리코드2"} />
                        <div className="selectArea">
                            <SelectSearch options={option.category_2} placeholder="--옵션선택--" onChange={(e) => siteCategoryTreeListAPI(e, 3)} />
                        </div>
                    </FormWrapper>
                    <FormWrapper>
                        <TitleWrapper title={"카테고리코드3"} />
                        <div className="selectArea">
                            <SelectSearch options={option.category_3} placeholder="--옵션선택--" onChange={(e) => setRegData(prev => ({ ...prev, selectOption: e }))} />
                        </div>
                    </FormWrapper>
                </div>
                <FormWrapper>
                    <TitleWrapper title={"판매자검색"} />
                    <input type={"text"} onChange={(e) => debouncedHandler.current(e.target.value)} />
                    {partnerList?.length > 0 ?
                        <div>
                            <button onClick={(e) => setPartnerList(null)}>닫기</button>
                            <ul>
                                {partnerList.map((item) =>
                                    <li key={item.PARTNER_CD} onClick={(e) => setSelectPartner(item)}><span>{item.PARTNER_NAME}</span></li>
                                )}
                            </ul>
                        </div>
                        : null}
                </FormWrapper>
                <div className={styles.listArea}>
                    <ScrollContainer horizontal={true} component={`ul`}>
                        {selectPartner !== null && <li key={selectPartner.PARTNER_CD} onClick={(e) => setSelectPartner(null)}><span>{selectPartner.PARTNER_NAME}</span><button><FontAwesomeIcon icon="fa-light fa-xmark" /></button></li>}
                    </ScrollContainer>
                </div>
                <FormWrapper>
                    <TitleWrapper title={"장르선택"} />
                    <div className="selectArea">
                        <SelectSearch options={vehicleTypeList} placeholder="--옵션선택--" value={null} onChange={(e) => chooseVehicleTypeHandler(e)} />
                    </div>
                </FormWrapper>
                <FormWrapper>
                    <div className={styles.listArea}>
                        <ScrollContainer horizontal={true} component={`ul`}>
                            {selectVehicleTypeList !== null && selectVehicleTypeList.map((item) => <li key={item.value} onClick={(e) => setSelectVehicleTypeList(prev => prev.filter(before => before !== item))}><span>{item.name}</span><button><FontAwesomeIcon icon="fa-light fa-xmark" /></button></li>)}
                        </ScrollContainer>
                    </div>
                </FormWrapper>
                {/* 옵션 */}
                <FormWrapper>
                    <TitleWrapper title={"옵션 설정"} />
                    <div className="radioArea"><div><input type="radio" name={"option_typ"} className="radio" id={"option_typ_2"} onChange={() => setOptionData(prev => ({ cnt: [makeRow()], active: true }))} />
                        <label htmlFor={"option_typ_2"} className="radio-label" >사용</label></div></div>
                    <div className="radioArea"><div><input type="radio" name={"option_typ"} className="radio" id={"option_typ_3"} onChange={() => setOptionData(prev => ({ ...prev, active: false }))} />
                        <label htmlFor={"option_typ_3"} className="radio-label" >미사용</label></div></div>
                </FormWrapper>
                <FormWrapper>
                    <TitleWrapper title={"응모상품여부"} />
                    <div className="radioArea"><div><input type="radio" name={"isRaffle_typ"} className="radio" id={"isRaffle_typ_2"} checked={regData.isRaffle === "Y" ? true : false} onChange={() => setRegData(prev => ({ ...prev, isRaffle: "Y" }))} />
                        <label htmlFor={"isRaffle_typ_2"} className="radio-label" >여</label></div></div>
                    <div className="radioArea"><div><input type="radio" name={"isRaffle_typ"} className="radio" id={"isRaffle_typ_3"} checked={regData.isRaffle === "N" ? true : false} onChange={() => setRegData(prev => ({ ...prev, isRaffle: "N" }))} />
                        <label htmlFor={"isRaffle_typ_3"} className="radio-label" >부</label></div></div>
                </FormWrapper>
                {optionData.active && optionData.cnt.map((item, idx) => (
                    <div className={styles.flexRow} key={item.id}>
                        <FormWrapper>
                            <TitleWrapper title={"옵션명"} />
                            <input type={"text"} ref={(el) => { if (!optionInputRef.current[idx]) optionInputRef.current[idx] = []; optionInputRef.current[idx][0] = el; }} onChange={() => onValidateHandler()} />
                        </FormWrapper>
                        <FormWrapper>
                            <TitleWrapper title={"옵션값"} />
                            <input type={"text"} ref={(el) => { if (!optionInputRef.current[idx]) optionInputRef.current[idx] = []; optionInputRef.current[idx][1] = el; }} onChange={(e) => { onValidateHandler(); onNumberCommaHandler(e); }} />
                        </FormWrapper>
                        <FormWrapper>
                            <TitleWrapper title={`${regData.isRaffle === "Y" ? "당첨" : "판매"} 가능한 재고 수량`} />
                            <input type={"text"} ref={(el) => { if (!optionInputRef.current[idx]) optionInputRef.current[idx] = []; optionInputRef.current[idx][2] = el; }} onChange={(e) => { onValidateHandler(); onNumberCommaHandler(e); }} />
                        </FormWrapper>
                        <button type='button' onClick={() => setOptionData(prev => { if ((prev.cnt?.length ?? 0) >= 10) { alert("옵션은 최대 10개까지 가능합니다."); return prev; } return { ...prev, cnt: [...prev.cnt, makeRow()] }; })}>+</button>
                        <button type='button' onClick={() => setOptionData(prev => {
                            if ((prev.cnt?.length ?? 0) <= 1) { alert("옵션은 최소 1개는 필요합니다."); return prev; } const nextCnt = prev.cnt.filter(r => r.id !== item.id);
                            const removedIndex = prev.cnt.findIndex(r => r.id === item.id);
                            if (removedIndex >= 0) optionInputRef.current.splice(removedIndex, 1);
                            return { ...prev, cnt: nextCnt };
                        })}>-</button>
                    </div>
                ))}
                <FormWrapper>
                    <TitleWrapper title={"제품명"} />
                    <input type={"text"} ref={el => (inputRef.current[0] = el)} onChange={() => onValidateHandler()} />
                </FormWrapper>
                <FormWrapper>
                    <TitleWrapper title={"제품 설명"} />
                    <input type={"text"} ref={el => (inputRef.current[1] = el)} onChange={() => onValidateHandler()} />
                </FormWrapper>
                <FormWrapper>
                    <TitleWrapper title={"정가"} />
                    <input type={"text"} ref={el => (inputRef.current[2] = el)} onChange={(e) => { onValidateHandler(); onNumberCommaHandler(e); }} />
                </FormWrapper>
                <FormWrapper>
                    <TitleWrapper title={`실제 ${regData.isRaffle === "Y" ? "당첨" : "판매"}가(노출 기준 가격)`} />
                    <input type={"text"} ref={el => (inputRef.current[3] = el)} placeholder='실제 판매가는 정가보다 높을수 없습니다.' onChange={(e) => { onValidateHandler(); onNumberCommaHandler(e); }} />
                </FormWrapper>
                <FormWrapper>
                    <TitleWrapper title={"출고 예정일"} />
                    <input type={"text"} ref={el => (inputRef.current[4] = el)} onChange={() => onValidateHandler()} />
                </FormWrapper>
                <FormWrapper>
                    <TitleWrapper title={"상품 상세 설명"} />
                    <input type={"text"} ref={el => (inputRef.current[5] = el)} onChange={() => onValidateHandler()} />
                </FormWrapper>
                {!optionData.active && <FormWrapper>
                    <TitleWrapper title={`${regData.isRaffle === "Y" ? "당첨" : "판매"} 가능한 재고 수량`} />
                    <input type={"text"} ref={el => (inputRef.current[6] = el)} onChange={(e) => { onValidateHandler(); onNumberCommaHandler(e); }} />
                </FormWrapper>}
                <FormWrapper>
                    <TitleWrapper title={"인당 구매 갯수 제한"} />
                    <input type={"text"} ref={el => (inputRef.current[10] = el)} onChange={(e) => { onValidateHandler(); onNumberCommaHandler(e); }} />
                </FormWrapper>
                <FormWrapper>
                    <TitleWrapper title={"기본 배송비(무료배송 조건 미충족 시 부과)"} />
                    <input type={"text"} ref={el => (inputRef.current[7] = el)} onChange={(e) => { onValidateHandler(); onNumberCommaHandler(e); }} />
                </FormWrapper>
                <FormWrapper>
                    <TitleWrapper title={"무료배송 기준 금액(주문 상품 금액이 해당 금액 이상이면 배송비 무료)"} />
                    <input type={"text"} ref={el => (inputRef.current[8] = el)} onChange={(e) => { onValidateHandler(); onNumberCommaHandler(e); }} />
                </FormWrapper>
                <FormWrapper>
                    <TitleWrapper title={"제주/도서산간 추가 배송비"} />
                    <input type={"text"} ref={el => (inputRef.current[9] = el)} onChange={(e) => { onValidateHandler(); onNumberCommaHandler(e); }} />
                </FormWrapper>
                <FormWrapper>
                    <TitleWrapper title={"배송 방식"} />
                    <div className="radioArea"><div><input type="radio" name={"img_typ"} className="radio" id={"ship_typ_1"} onChange={() => setRegData(prev => ({ ...prev, selectRadio: 1 }))} />
                        <label htmlFor={"ship_typ_1"} className="radio-label" >판매자배송</label></div></div>
                    <div className="radioArea"><div><input type="radio" name={"img_typ"} className="radio" id={"ship_typ_2"} onChange={() => setRegData(prev => ({ ...prev, selectRadio: 2 }))} />
                        <label htmlFor={"ship_typ_2"} className="radio-label" >풀필먼트</label></div></div>
                    <div className="radioArea"><div><input type="radio" name={"img_typ"} className="radio" id={"ship_typ_3"} onChange={() => setRegData(prev => ({ ...prev, selectRadio: 3 }))} />
                        <label htmlFor={"ship_typ_3"} className="radio-label" >위탁배송</label></div></div>
                </FormWrapper>
                <FormWrapper>
                    <TitleWrapper title={`${regData.isRaffle === "Y" ? "응모" : "판매"} 시작일`} />
                    <input onChange={(e) => setStartDate(new Date(e.target.value))} type="datetime-local" placeholder={'선택하세요'} value={startDate ? toDateTimeLocalValue(startDate) : ""} />
                </FormWrapper>
                <FormWrapper>
                    <TitleWrapper title={`${regData.isRaffle === "Y" ? "응모" : "판매"} 종료일`} />
                    <input onChange={(e) => setEndDate(new Date(e.target.value))} type="datetime-local" placeholder={'선택하세요'} value={endDate ? toDateTimeLocalValue(endDate) : ""} />
                </FormWrapper>
            </Element>
        </>
    );
})
export default Form;